import { render } from "./RecruitmentStatus.vue?vue&type=template&id=762c349e&scoped=true"
import script from "./RecruitmentStatus.vue?vue&type=script&lang=js"
export * from "./RecruitmentStatus.vue?vue&type=script&lang=js"

import "./RecruitmentStatus.vue?vue&type=style&index=0&id=762c349e&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762c349e"]])

export default __exports__